import SelectPerson from './SelectPerson'

export default SelectPerson